export default {
  pink: {
    color: '#FF32AA',
  },
  blue: {
    color: '#2B8CFF',
  },
  purple: {
    color: '#C001F0',
  },
  jade: {
    color: '#2BBA8B',
  },
  green: {
    color: '#179615',
  },
  lime: {
    color: '#2bba8b',
  },
  mustard: {
    color: '#A18C11',
  },
  yellow: {
    color: '#FFDD86',
  },
  orange: {
    color: '#FF6B00',
  },
  red: {
    color: '#C6230D',
  },
  fawn: {
    color: '#735d0c',
  },
  concrete: {
    color: '#A3A8A8',
  },
  moss: {
    color: '#0d7352',
  },
  dust: {
    color: '#994000',
  },
}
